var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"product",attrs:{"src":`/productImg/${_vm.image}.jpg`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }